import * as Sentry from '@sentry/react';
import { useCallback } from 'react';

import css from './error-boundary.css';

const ErrorMessage: FC<{
    error: Error;
    resetError: () => void;
    componentStack: string;
}> = ({ componentStack, error, resetError }) => (
    <div className={css.error}>
        <div>Опс, мы сломались :(((</div>
        <button onClick={resetError}>Попробовать еще раз</button>
        <div>{error.toString()}</div>
        <div>{componentStack}</div>
    </div>
);

export const ErrorBoundary: FC<{
    data?: AnyObject<PrimitiveValue>;
    children?: ReactNode;
}> = ({ children, data = {} }) => {
    const beforeCapture = useCallback(
        (scope: Sentry.Scope) => {
            scope.setTags(data);
        },
        [data],
    );
    return (
        <Sentry.ErrorBoundary
            beforeCapture={beforeCapture}
            fallback={({ componentStack, error, resetError }) => (
                <ErrorMessage componentStack={componentStack} error={error} resetError={resetError} />
            )}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};
